<template>
  <g-dialog
    v-model="dialogOpen"
    width="580"
    title="End User License Agreement (EULA)"
    :show-back-button="false"
    :show-close-button="false"
    :action-buttons="buttons"
    fixed-buttons-for-overflow
  >
    <EULADocument />
    <intersect-observer @intersected="enableAccept" />
  </g-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import IntersectObserver from '@/components/generic/IntersectObserver.vue';
import GDialog from '../generic/GDialog.vue';
import EULADocument from './EULADocument.vue';

export default {
  name: 'EULADialog',

  components: {
    EULADocument,
    GDialog,
    IntersectObserver,
  },

  data() {
    return {
      dialogOpen: false,
      loading: false,
      acceptable: false,
    };
  },

  computed: {
    ...mapState('user', ['shouldShowEULAPrompt', 'shouldShowTermsOfUsePrompt']),
    ...mapState('app', ['isMimic']),

    buttons() {
      return [
        {
          name: 'I DO NOT ACCEPT',
          side: 'right',
          type: 'default',
          onClick: this.handleCancelClick,
          loading: this.loading,
        },
        {
          name: 'I ACCEPT',
          side: 'right',
          type: 'primary',
          full: this.$isMobile ? null : true,
          disabled: !this.acceptable,
          onClick: this.handleSubmit,
          loading: this.loading,
        },
      ];
    },
  },

  mounted() {
    this.dialogOpen = this.shouldShowEULAPrompt && !this.isMimic && !this.shouldShowTermsOfUsePrompt;
  },

  methods: {
    ...mapActions('user', ['toggleShouldShowEULAPrompt']),

    handleCancelClick() {
      this.loading = true;
      window.location = '/logout/';
    },

    enableAccept() {
      this.acceptable = true;
    },

    async handleSubmit() {
      this.loading = true;
      try {
        await this.toggleShouldShowEULAPrompt();
        this.dialogOpen = false;
      } catch (e) {
        this.$snackbar.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
